import { lazy, type FC, type ReactElement, Suspense } from 'react'

import { Loader } from '../components/Loader'

const LazyTrustedDeviceManagementPage = lazy(() =>
  import('../pages/TrustedDeviceManagement/TrustedDeviceManagementPage').then((module) => ({
    default: module.TrustedDeviceManagementPage,
  })),
)

export const TrustedDeviceManagementRoute: FC = (): ReactElement => {
  return (
    <Suspense fallback={<Loader />}>
      <LazyTrustedDeviceManagementPage />
    </Suspense>
  )
}
